import React, { useEffect, useState } from 'react';
import Switch from 'react-switch';
import Select from 'react-select';
import PredictiveMap from './PredictiveMap';
import PredictiveCharts from './PredictiveCharts';

const PredictivePage = (props) => {
    console.log("Rendering PredictivePage", props);
    const {
        getHotspots,
        getTrends,
        getForecast,
        setFilters,
        predictiveAnalysis: { hotspots, hourlyTrends, weeklyTrends, forecast, loader, filters },
        emergencyTypes,
        getEmergencyTypes
    } = props;

    const [selectedType, setSelectedType] = useState(null);

    useEffect(() => {
        getEmergencyTypes();
        fetchData();
    }, []);

    const fetchData = (newFilters = filters) => {
        const params = {};
        if (newFilters.emergency_type_id) {
            params.emergency_type_id = newFilters.emergency_type_id;
        }
        getHotspots(params);
        getTrends(params);
        getForecast(params);
    };

    const handleTypeChange = (option) => {
        const typeId = option ? option.value : null;
        setSelectedType(option);
        const newFilters = { ...filters, emergency_type_id: typeId };
        setFilters(newFilters);
        fetchData(newFilters);
    };

    const typeOptions = emergencyTypes.map(type => ({
        value: type.id,
        label: type.name
    }));

    return (
        <div className="container-fluid py-4">
            <div className="d-flex align-items-center mb-4">
                <i className="material-icons text-primary mr-2" style={{ fontSize: '32px' }}>auto_graph</i>
                <h2 className="mb-0 font-weight-bold">Bomberos Predict (REAL VIEW)</h2>
                <div className="ml-auto" style={{ width: '300px' }}>
                    <Select
                        isClearable
                        placeholder="Filtrar por tipo de emergencia..."
                        options={typeOptions}
                        value={selectedType}
                        onChange={handleTypeChange}
                        className="react-select-container"
                        classNamePrefix="react-select"
                    />
                </div>
            </div>

            <div className="row">
                {/* MAP SECTION */}
                <div className="col-lg-8 mb-4">
                    <div className="card border-0 shadow-sm" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                        <div className="card-header bg-white border-0 py-3 d-flex align-items-center">
                            <i className="material-icons text-danger mr-2">local_fire_department</i>
                            <h5 className="mb-0 font-weight-bold">Mapa de Puntos Calientes (Hotspots)</h5>
                        </div>
                        <div className="card-body p-0" style={{ height: '500px' }}>
                            <PredictiveMap hotspots={hotspots} loader={loader} />
                        </div>
                    </div>
                </div>

                {/* STATS SUMMARY */}
                <div className="col-lg-4 mb-4">
                    <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
                        <div className="card-header bg-white border-0 py-3">
                            <h5 className="mb-0 font-weight-bold">Resumen de Riesgo</h5>
                        </div>
                        <div className="card-body d-flex flex-column justify-content-around">
                            <div className="text-center p-3 mb-3" style={{ background: '#f8f9fa', borderRadius: '12px' }}>
                                <span className="text-secondary d-block mb-1">Incidentes Analizados</span>
                                <h2 className="text-primary font-weight-bold mb-0">{props.predictiveAnalysis.totalIncidents}</h2>
                            </div>
                            
                            <div className="p-3" style={{ background: '#fff5f5', borderRadius: '12px', borderLeft: '4px solid #dc3545' }}>
                                <h6 className="font-weight-bold text-danger mb-2">Zona de Mayor Riesgo</h6>
                                <p className="mb-0 text-dark">
                                    {hotspots.length > 0 ? 'Detectada alta densidad en sector centro.' : 'No hay datos suficientes.'}
                                </p>
                            </div>

                            <div className="mt-4">
                                <h6 className="font-weight-bold mb-3">Recomendación</h6>
                                <div className="alert alert-info border-0 shadow-none" style={{ borderRadius: '10px' }}>
                                    <small>Se sugiere posicionar una unidad de refuerzo en los clusters rojos durante las próximas horas pico.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-12">
                    <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                        <div className="card-header bg-white border-0 py-3 d-flex align-items-center">
                            <i className="material-icons text-warning mr-2">event_note</i>
                            <h5 className="mb-0 font-weight-bold">Próximos Riesgos Detectados (Pronóstico)</h5>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-hover border-0">
                                    <thead>
                                        <tr className="text-secondary small text-uppercase">
                                            <th className="border-0">Fecha / Día</th>
                                            <th className="border-0">Ventana Horaria</th>
                                            <th className="border-0">Categoría</th>
                                            <th className="border-0">Tipo de Emergencia</th>
                                            <th className="border-0">Nivel de Riesgo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {forecast && forecast.length > 0 ? (
                                            forecast.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td className="align-middle">
                                                        <span className="font-weight-bold">{item.date}</span>
                                                        <small className="d-block text-muted">{item.day}</small>
                                                    </td>
                                                    <td className="align-middle">
                                                        <span className="badge badge-light p-2" style={{ fontSize: '0.9rem' }}>
                                                            {item.hour_window}
                                                        </span>
                                                    </td>
                                                    <td className="align-middle">{item.emergency_category}</td>
                                                    <td className="align-middle text-primary font-weight-bold">{item.emergency_type}</td>
                                                    <td className="align-middle">
                                                        <span className={`badge badge-pill ${item.risk_level === 'Alto' ? 'badge-danger' : 'badge-warning'} px-3 py-2`}>
                                                            {item.risk_level}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center py-4">No se detectaron riesgos inminentes con los filtros actuales.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                        <div className="card-header bg-white border-0 py-3 d-flex align-items-center">
                            <i className="material-icons text-warning mr-2">schedule</i>
                            <h5 className="mb-0 font-weight-bold">Análisis de Tendencias (Datos Históricos)</h5>
                        </div>
                        <div className="card-body">
                            <PredictiveCharts hourly={hourlyTrends} weekly={weeklyTrends} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PredictivePage;
